import { PRESENT_VALUE_SENTINEL } from '../../../types/QueryBuilder';
import type { Operator } from '../../../types/QueryBuilder';

/**
 * True when a FILTER token's value is the portable "field is present" sentinel
 * (`__present__`), including the single-element array form the parser can emit.
 */
export function isPresentSentinelValue(value: unknown): boolean {
  return (
    value === PRESENT_VALUE_SENTINEL ||
    (Array.isArray(value) && value.length === 1 && value[0] === PRESENT_VALUE_SENTINEL)
  );
}

/**
 * True when a present-sentinel filter means "does not exist".
 *
 * Either the `!` prefix or the `!=` operator can flip the semantic — XOR them
 * so `field:!=:__present__` and `!field:=:__present__` both mean absence, and
 * `!field:!=:__present__` means presence.
 */
export function isPresentAbsence(token: { negated?: boolean; operator: Operator }): boolean {
  return !!token.negated !== (token.operator === '!=');
}
